// Tabbed Product Carousel - Optimized for Performance
// Uses requestIdleCallback to avoid blocking LCP/FCP

function initTabCarousel() {

  // ─── Tab Switching Logic ───────────────────────────────────────────────────
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabPanes   = document.querySelectorAll(".tab-pane");

  tabButtons.forEach(button => {
    button.addEventListener("click", function () {
      tabButtons.forEach(btn  => btn.classList.remove("active"));
      tabPanes.forEach(pane   => pane.classList.remove("active"));
      this.classList.add("active");
      const target = document.getElementById(this.getAttribute("data-tab"));
      if (target) target.classList.add("active");
    });
  });

  // ─── Carousel Navigation Logic ────────────────────────────────────────────
  document.querySelectorAll(".tab-container").forEach(container => {
    const prevBtn = container.querySelector(".carousel-prev");
    const nextBtn = container.querySelector(".carousel-next");
    if (!prevBtn || !nextBtn) return;

    const getActiveCarousel = () =>
      container.querySelector(".tab-pane.active .product-carousel");

    prevBtn.addEventListener("click", function () {
      const carousel = getActiveCarousel();
      if (carousel) carousel.scrollBy({ left: -carousel.offsetWidth / 3, behavior: "smooth" });
    });

    nextBtn.addEventListener("click", function () {
      const carousel = getActiveCarousel();
      if (carousel) carousel.scrollBy({ left: carousel.offsetWidth / 3, behavior: "smooth" });
    });
  });

  // ─── Deferred Lazy Image Loading ──────────────────────────────────────────
  // Native loading="lazy" doesn't reliably respect horizontal scroll clipping.
  // IntersectionObserver correctly handles overflow, so images only fetch
  // when actually scrolled into view.
  const lazyImages = document.querySelectorAll("img.lazy-carousel-img");

  if (lazyImages.length) {
    const upgradeImage = img => {
      if (img.dataset.sizes)  img.sizes  = img.dataset.sizes;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src)    img.src    = img.dataset.src;
      img.removeAttribute("data-sizes");
      img.removeAttribute("data-srcset");
      img.removeAttribute("data-src");
      img.classList.remove("lazy-carousel-img");
    };

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            upgradeImage(entry.target);
            obs.unobserve(entry.target);
          });
        },
        { rootMargin: "200px 300px", threshold: 0.01 }
      );
      lazyImages.forEach(img => observer.observe(img));
    } else {
      // Fallback for older browsers
      lazyImages.forEach(upgradeImage);
    }
  }
}

// ─── Run after page is interactive, not during critical render path ──────────
// requestIdleCallback ensures we don't block LCP or FCP
if ("requestIdleCallback" in window) {
  requestIdleCallback(initTabCarousel, { timeout: 2000 });
} else {
  // Fallback: run after full page load
  window.addEventListener("load", initTabCarousel);
}